import {FormatDateTimeEntryToLocaleString} from "../../../../utils/date";

export class Screenshot {
    constructor(props = {}) {
        const {clientId, clientName, screenshotPath, screenshotDate, timeOnDevice, validity, detailId} = props;

        this.id = clientId;
        this.name = clientName;
        if (screenshotDate) {
            this.created_at = FormatDateTimeEntryToLocaleString(screenshotDate);
        }
        else {
            this.created_at = '';
        }
        this.screenshotPath = screenshotPath;
        if (timeOnDevice) {
            this.timeOnDevice = FormatDateTimeEntryToLocaleString(timeOnDevice);
        }
        else {
            this.timeOnDevice = '';
        }
        this.validity = validity;
        this.detailId = detailId;
    }
}
